import * as React from 'react';
import * as styles from '../../styles/row.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Row = function Row(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: styles['row'],
    children: children
  });
};
Row.displayName = 'Row';